import styled from 'styled-components';
import { Caption, fontWeights, spacing } from 'ui/theme';

export const StyledAffinityCounts = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${spacing.half};
`;

export const AffinityTopFlex = styled(StyledAffinityCounts)`
  margin-bottom: ${spacing.quarter};
  align-items: center;
`;

export const BoldCaption = styled(Caption)`
  font-weight: ${fontWeights.semiBold};
`;
